import { lit, st } from "rdflib";
import { vcard } from "../namespaces.js";
export function renameContact(store, contactNode, newName) {
    const deletions = store.statementsMatching(contactNode, vcard("fn"), null, null);
    const insertions = deletions.map((it) => st(it.subject, it.predicate, lit(newName), it.graph));
    return {
        insertions,
        deletions,
        filesToCreate: [],
    };
}
//# sourceMappingURL=renameContact.js.map